import {
    IServiceCnsSettlement,
    IServiceCnsMiscActivity,
    IServicePositionPriorNight,
    IServiceSFTPReportsGetQuery,
    IServiceCnsOpeningPosition,
    ListResult,
} from '@shared/api';
import { Api } from '../../Api';

export class SFTPReports {
    private static _basePath = '/SFTPReports';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${SFTPReports._basePath}`;
        return {
            async getPositionPriorNight(query: IServiceSFTPReportsGetQuery) {
                const path = `/cns-prior-night`;
                return await Api.get<ListResult<IServicePositionPriorNight>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getCnsMiscActivity(query: IServiceSFTPReportsGetQuery) {
                const path = `/cns-misc-activity`;
                return await Api.get<ListResult<IServiceCnsMiscActivity>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getCnsNightSettlement(query: IServiceSFTPReportsGetQuery) {
                const path = `/cns-night-settlement`;
                return await Api.get<ListResult<IServiceCnsSettlement>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getCnsDaySettlement(query: IServiceSFTPReportsGetQuery) {
                const path = `/cns-day-settlement`;
                return await Api.get<ListResult<IServiceCnsSettlement>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getCnsOpeningPosition(query: IServiceSFTPReportsGetQuery) {
                const path = `/cns-opening-position`;
                return await Api.get<ListResult<IServiceCnsOpeningPosition>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
        };
    }
}
